var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.markup.length)?_c('div',{class:[
		'html-content',
		_vm.lineClamp
	],domProps:{"innerHTML":_vm._s(_vm.markup)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }